import type { HttpCore } from '../http';
import type { Notification, NotificationsQuery, OkResponse, Paged } from '../types';

/** `/api/v1/notifications` — the in-app inbox (email copies live in the same collection). */
export function createNotificationsApi(http: HttpCore) {
  return {
    list: (query: NotificationsQuery = {}) =>
      http.get<Paged<Notification>>('/notifications', {
        query: { unread: query.unread ? 'true' : undefined, page: query.page, pageSize: query.pageSize },
      }),
    markRead: (id: string) => http.post<OkResponse>(`/notifications/${encodeURIComponent(id)}/read`),
    markAllRead: () => http.post<OkResponse>('/notifications/read-all'),
  };
}

export type NotificationsApi = ReturnType<typeof createNotificationsApi>;
